<template>
  <div class="ai-block">
    <div v-if="block.type === 'text'" class="ai-block-text">{{ block.text }}</div>
    <AiTableBlock
      v-else-if="block.type === 'table' || block.type === 'sql_table'"
      :block="block"
    />
    <AiChartBlock v-else-if="block.type === 'chart'" :block="block" />
    <AiFileBlock v-else-if="block.type === 'file'" :block="block" />
    <AiAskUserBlock v-else-if="block.type === 'ask_user'" :block="block" />
    <AiChipsBlock
      v-else-if="block.type === 'chips'"
      :block="block"
      :interactive="chipsInteractive"
      @send="(item) => $emit('chip-send', item)"
    />
    <AiCollapsibleBlock
      v-else-if="block.type === 'thinking' || block.type === 'tool_call'"
      :block="block"
    />
    <div v-else-if="block.type === 'error'" class="ai-block-error">
      ⚠️ {{ block.detail }}
    </div>
    <div v-else class="ai-block-unknown">Блок «{{ block.type }}» не поддерживается</div>
  </div>
</template>

<script>
import AiTableBlock from './AiTableBlock.vue';
import AiChartBlock from './AiChartBlock.vue';
import AiFileBlock from './AiFileBlock.vue';
import AiCollapsibleBlock from './AiCollapsibleBlock.vue';
import AiAskUserBlock from './AiAskUserBlock.vue';
import AiChipsBlock from './AiChipsBlock.vue';

export default {
  name: 'AiBlock',
  components: { AiTableBlock, AiChartBlock, AiFileBlock, AiCollapsibleBlock, AiAskUserBlock, AiChipsBlock },
  props: {
    block: { type: Object, required: true },
    chipsInteractive: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ai-block {
  min-width: 0;
  max-width: 100%;
}

.ai-block-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

.ai-block-unknown {
  color: #98a2b3;
  font-size: 12px;
  font-style: italic;
}

.ai-block-error {
  color: #dc2626;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
